import { Card, CardContent, View, Image } from "@/components/ui";
import { CaretRight } from "@/components/shared/icons";
import { useRoute } from "@/components/shared/router";
import { useAuthState } from "@/store/auth";
import { formatPrice } from "@/lib/helpers/number";

import { Typography } from "@/components/shared/typography";
import WalletIcon from "@/assets/images/3d-icons/wallet.png";
import { CreditTypeEnum } from "@/__generated__/graphql";

export const CreditAccount = () => {
  const { push } = useRoute();
  const {
    data: { userInfo },
  } = useAuthState();
  const creditAccountBalance = userInfo.creditAccounts
    .filter(
      (credit) =>
        credit.creditType === CreditTypeEnum.Department ||
        credit.creditType === CreditTypeEnum.General,
    )
    .reduce((sum, credit) => sum + (credit.balance ?? 0), 0);

  const handleGotoCreditAccount = () => {
    push({
      pageKey: "creditAccount",
    });
  };
  return (
    <Card
      border="none"
      className="flex-1 cursor-pointer"
      onClick={handleGotoCreditAccount}
    >
      <CardContent className="flex flex-col gap-2 px-3 py-2">
        <View className="flex flex-row items-start justify-between">
          <Image src={WalletIcon} width={32} height={32} />
        </View>
        <View>
          <View className="flex flex-row items-center justify-between gap-1">
            <Typography variant="caption-md" color="foreground-intermediate">
              Account Credit
            </Typography>
            <CaretRight size={16} className="text-foreground-attenuated" />
          </View>
          <Typography color="brand-primary" variant="label-sm">
            {formatPrice(creditAccountBalance)}
          </Typography>
        </View>
      </CardContent>
    </Card>
  );
};
